import IteneraryForm from "./IteneraryForm";

const ItenerayPopup = ({
  formikData,
  anchorEl,
  handleClose,
  basePath,
  option,
  carrierCode,
  copySources,
  airLineList,
  airPort,
  originAirport,
  destAirport,
}) => {
  if (!anchorEl) return null;

  return (
    <div
      style={{
        background: "rgba(0, 0, 0, 0.45)",
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleClose();
      }}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col"
        style={{ width: "min(880px, 95vw)", maxHeight: "90vh" }}
      >
        <IteneraryForm
          formikData={formikData}
          basePath={basePath}
          option={option}
          carrierCode={carrierCode}
          copySources={copySources}
          airLineList={airLineList}
          airPort={airPort}
          handleClose={handleClose}
          originAirport={originAirport}
          destAirport={destAirport}
        />
      </div>
    </div>
  );
};

export default ItenerayPopup;
